package pl.michal_cyran.portfolio.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.dom.svg.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssRule
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.theme.SilkTheme
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.css.vh
import pl.michal_cyran.portfolio.components.sections.Footer
import pl.michal_cyran.portfolio.components.sections.NavHeader
import pl.michal_cyran.portfolio.toSitePalette

val PageContentStyle = CssStyle {
    base { Modifier.fillMaxSize().padding(leftRight = 1.cssRem) }
    Breakpoint.MD { Modifier.maxWidth(80.cssRem) }

    cssRule("body") {
        Modifier
            .backgroundColor(
                colorMode.toSitePalette().background
            )
    }
}



class PageLayoutData(val title: String)

@Composable
@Layout
fun PageLayout(ctx: PageContext, content: @Composable ColumnScope.() -> Unit) {
    val data = ctx.data.getValue<PageLayoutData>()
    LaunchedEffect(data.title) {
        document.title = data.title
    }
//
//    Box(
//        Modifier
//            .fillMaxWidth()
//            .minHeight(100.vh)
//            // Create a box with two rows: the main content (fills as much space as it can) and the footer (which reserves
//            // space at the bottom). "min-content" means the use the height of the row, which we use for the footer.
//            // Since this box is set to *at least* 100%, the footer will always appear at least on the bottom but can be
//            // pushed further down if the first row grows beyond the page.
//            // Grids are powerful but have a bit of a learning curve. For more info, see:
//            // https://css-tricks.com/snippets/css/complete-guide-grid/
//            .gridTemplateRows { size(1.fr); size(minContent) },
//        contentAlignment = Alignment.Center
//    ) {
////        SvgCobweb(Modifier.gridRow(1).align(Alignment.TopStart))
        Column(
            // Isolate the content, because otherwise the absolute-positioned SVG above will render on top of it.
            // This is confusing but how browsers work. Read up on stacking contexts for more info.
            // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_positioned_layout/Understanding_z-index/Stacking_context
            // Some people might have used z-index instead, but best practice is to avoid that if possible, because
            // as a site gets complex, Z-fighting can be a huge pain to track down.
            Modifier.fillMaxSize().gridRow(1),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            NavHeader()
            Div(PageContentStyle.toAttrs()) {
                content()
            }
        }
//        // Associate the footer with the row that will get pushed off the bottom of the page if it can't fit.
////        Footer(Modifier.fillMaxWidth().gridRow(2))
//    }
}
